import { render, staticRenderFns } from "./DailyDealBanner.vue?vue&type=template&id=397c4440"
import script from "./DailyDealBanner.vue?vue&type=script&lang=ts"
export * from "./DailyDealBanner.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports